module.exports = __webpack_public_path__ + "static/media/RNSSanz-Bold.52f5b2b4.ttf";